<template>
  <v-container fluid>
    <v-dialog
      v-model="show"
      transition="dialog-bottom-transition"
      max-width="1500"
      scrollable
    >
      <v-card class="pa-4 listing-detail-card" elevation="3">
        <!-- CLOSE BUTTON -->
        <v-btn
          icon
          class="position-relative top-0 right-0 ma-2"
          @click.stop="close"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <!-- HERO IMAGES + VERIFIED BADGE + AGENT CARD -->
        <v-row dense justify-space-between class="mb-6">
          <!-- main image with badge overlay -->
          <v-col cols="12" md="8">
            <div class="hero-wrapper">
              <v-img
                :src="mainImage"
                style="object-fit: cover"
                height="auto"
                class="mx-auto"
              />
              <v-chip
                small
                :color="isVerified ? 'success' : 'grey lighten-1'"
                text-color="white"
                class="verified-badge"
              >
                {{ isVerified ? "Verified" : "Unverified" }}
              </v-chip>
            </div>
          </v-col>

          <!-- thumbnails + agent -->
          <v-col
            cols="12"
            md="4"
            class="d-flex flex-column"
            style="position: relative"
          >
            <v-img
              v-for="(img, i) in otherImages"
              :key="i"
              :src="img"
              height="115"
              cover
              class="rounded mb-2"
            />

            <!-- agent card -->
          </v-col>
        </v-row>

        <!--Properties-->
        <v-row v-if="listingType === 'property'" class="listing-detail-card">
          <v-col cols="6" md="4">
            <div class="">
              <span class="currency-details">{{ currency }} </span> {{ " " }}
              <span class="price-details"> {{ formattedPrice }}</span>

              <span v-if="priceFrequency" class="body-2">
                {{ priceFrequency }}</span
              >
            </div>
            <div class="d-flex align-center">
              <span v-if="bedrooms" class="d-flex align-center mr-4">
                <v-icon small class="mr-1">mdi-bed-queen-outline</v-icon>
                {{ bedrooms }} BR
              </span>

              <span v-if="bathrooms" class="d-flex align-center mr-4">
                <v-icon small class="mr-1">mdi-shower</v-icon>
                {{ bathrooms }} Baths
              </span>

              <span v-if="area" class="d-flex align-center">
                <v-icon small class="mr-1">mdi-ruler-square</v-icon>
                {{ area }} sqft
              </span>
            </div>

            <div class="mt-2">
              <span v-if="city">
                <v-icon small class="mr-1">mdi-map-marker-outline</v-icon
                >{{ listing?.location?.location_name }}, {{ "Somalia" }}</span
              >
            </div>
          </v-col>

          <!--End of properties-->

          <v-col cols="6" md="4">
            <div class="mt-4 d-flex" style="margin-right: 80px">
              <v-btn
                dense
                small
                variant="outlined"
                class="mx-1 favorite-btn"
                @click="toggleFavorite"
              >
                <v-icon small left :color="isFavorited ? 'red' : ''"
                  >mdi-heart{{ isFavorited ? "" : "-outline" }}</v-icon
                >
                Favorite
              </v-btn>
              <v-btn
                dense
                small
                variant="outlined"
                class="mx-1 favorite-btn"
                @click="openShare(listing)"
              >
                <v-icon left>mdi-share-variant</v-icon>Share
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="agent-card-new pa-4" elevation="2">
              <v-row no-gutters align="center">
                <!-- Agent photo -->
                <v-col cols="3">
                  <v-avatar size="70" class="elevation-1" rounded="0">
                    <img
                      :src="agent.agentPhoto || require('@/assets/avatar.png')"
                      alt="agent photo"
                      style="object-fit: cover; width: 100%; height: 70px"
                    />
                  </v-avatar>
                </v-col>
                <!-- Agent info -->
                <v-col cols="9" class="pl-2">
                  <div class="agent-name">{{ agent.agentName }}</div>
                  <!-- <router-link to="#_" class="agent-view-link">
                    View All Properties
                  </router-link> -->
                  <span class="agent-joined-date">
                    Joined on {{ agent.agentJoiningDate || "N/A" }}
                  </span>
                  <!-- <div class="agent-office">
            Urban Nest <br />
            Business Center <v-icon size="16" color="#8b8b8b">mdi-chevron-right</v-icon>
          </div> -->
                </v-col>
              </v-row>

              <v-row class="mt-4" no-gutters>
                <v-col>
                  <v-btn
                    class="contact-btn email"
                    :href="`mailto:?subject=${encodeURIComponent(
                      emailSubject
                    )}&body=${encodeURIComponent(currentShareUrl)}`"
                    variant="outlined"
                    block
                  >
                    <v-icon left color="#2260cf">mdi-email</v-icon>
                    Email
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    class="contact-btn call"
                    @click="callAgent"
                    variant="outlined"
                    block
                  >
                    <v-icon left color="#ef5959">mdi-phone</v-icon>
                    Call
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    class="contact-btn whatsapp"
                    :href="`https://wa.me/?text=${encodeURIComponent(
                      currentShareUrl
                    )}`"
                    target="_blank"
                    variant="outlined"
                    block
                  >
                    <v-icon color="#1bc557">mdi-whatsapp</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
            <div style="margin-top: 15px">
              <!-- <v-btn
                class="chat-seller-btn"
                :disabled="isSelf"
                @click="chatWithSeller"
                variant="flat"
              >
                <v-icon left>mdi-message-reply-text-outline</v-icon>
                Chat with Seller
              </v-btn> -->
            </div>
          </v-col>
        </v-row>
        <!--End of Properties-->

        <!--Cars-->
        <v-row v-if="listingType === 'car'">
          <v-col cols="6" md="4">
            <div class="">
              <span class="currency-details">{{ currency }} </span> {{ " " }}
              <span class="price-details"> {{ formattedPrice }}</span>

              <span v-if="priceFrequency" class="body-2">
                {{ priceFrequency }}</span
              >
            </div>

            <div class="d-flex align-center">
              <span
                v-if="listingType === 'car'"
                class="d-flex align-center mr-4"
              >
                <v-icon small class="mr-1">mdi-calendar-outline</v-icon>
                {{ listing.details.year || "N/A" }}
              </span>

              <span v-if="listing.car" class="d-flex align-center mr-4">
                <v-icon small class="mr-1">mdi-gauge-full</v-icon>
                {{ listing.details.kilometers || "N/A" }} km
              </span>

              <span v-if="listing.car" class="d-flex align-center">
                <v-icon small class="mr-1">mdi-web</v-icon>
                {{ listing.details.specs || "N/A" }}
              </span>
            </div>

            <div class="mt-2">
              <span v-if="city">
                <v-icon small class="mr-1">mdi-map-marker-outline</v-icon
                >{{ listing?.location?.location_name }}, {{ "Somalia" }}</span
              >
            </div>
          </v-col>

          <v-col cols="6" md="4">
            <div class="mt-4 d-flex" style="margin-right: 80px">
              <v-btn
                dense
                small
                variant="outlined"
                class="mx-1 favorite-btn"
                @click="toggleFavorite"
              >
                <v-icon small left :color="isFavorited ? 'red' : ''"
                  >mdi-heart{{ isFavorited ? "" : "-outline" }}</v-icon
                >
                Favorite
              </v-btn>
              <v-btn
                dense
                small
                variant="outlined"
                class="mx-1 favorite-btn"
                @click="openShare(listing)"
              >
                <v-icon left>mdi-share-variant</v-icon>Share
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="agent-card-new pa-4" elevation="2">
              <v-row no-gutters align="center">
                <!-- Agent photo -->
                <v-col cols="3">
                  <v-avatar size="70" class="elevation-1" rounded="0">
                    <img
                      :src="agent.agentPhoto || require('@/assets/avatar.png')"
                      alt="agent photo"
                      style="object-fit: cover; width: 100%; height: 70px"
                    />
                  </v-avatar>
                </v-col>
                <!-- Agent info -->
                <v-col cols="9" class="pl-2">
                  <div class="agent-name">{{ agent.agentName }}</div>
                  <!-- <router-link to="#_" class="agent-view-link">
                    View All Cars
                  </router-link> -->
                  <span class="agent-joined-date">
                    Joined on {{ agent.agentJoiningDate || "N/A" }}
                  </span>
                  <!-- <div class="agent-office">
            Urban Nest <br />
            Business Center <v-icon size="16" color="#8b8b8b">mdi-chevron-right</v-icon>
          </div> -->
                </v-col>
              </v-row>

              <v-row class="mt-4" no-gutters>
                <v-col>
                  <v-btn
                    class="contact-btn email"
                    :href="`mailto:?subject=${encodeURIComponent(
                      emailSubject
                    )}&body=${encodeURIComponent(currentShareUrl)}`"
                    variant="outlined"
                    block
                  >
                    <v-icon left color="#2260cf">mdi-email</v-icon>
                    Email
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    class="contact-btn call"
                    @click="callAgent"
                    variant="outlined"
                    block
                  >
                    <v-icon left color="#ef5959">mdi-phone</v-icon>
                    Call
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    class="contact-btn whatsapp"
                    :href="`https://wa.me/?text=${encodeURIComponent(
                      currentShareUrl
                    )}`"
                    target="_blank"
                    variant="outlined"
                    block
                  >
                    <v-icon color="#1bc557">mdi-whatsapp</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
            <div style="margin-top: 15px">
              <v-btn
                class="chat-seller-btn"
                :disabled="isSelf"
                @click="chatWithSeller"
                variant="flat"
              >
                <v-icon left>mdi-message-reply-text-outline</v-icon>
                Chat with Seller
              </v-btn>
            </div>
          </v-col>
          <v-divider class="my-4"></v-divider>

          <v-col cols="8">
            <div class="text-h6 font-weight-bold mb-6">Car Overview</div>
            <v-row>
              <!-- Left Column -->
              <v-col cols="8" md="6">
                <div class="overview-row" v-if="listing?.details?.bodyType">
                  <span class="overview-label">Body Type</span>
                  <span class="overview-value">{{
                    listing.details.bodyType
                  }}</span>
                </div>
                <div class="overview-row" v-if="listing?.details?.doors">
                  <span class="overview-label">Doors</span>
                  <span class="overview-value"
                    >{{ listing.details.doors }} doors</span
                  >
                </div>
                <div
                  class="overview-row"
                  v-if="listing?.details?.seating_capacity"
                >
                  <span class="overview-label">Seating Capacity</span>
                  <span class="overview-value"
                    >{{ listing.details.seating_capacity }} Seater</span
                  >
                </div>
                <div class="overview-row" v-if="listing?.car?.engine_capacity">
                  <span class="overview-label">Engine Capacity (cc)</span>
                  <span class="overview-value">{{
                    listing?.details?.engine_capacity
                  }}</span>
                </div>
                <div
                  class="overview-row"
                  v-if="listing?.details?.numOfCylinder"
                >
                  <span class="overview-label">No. of Cylinders</span>
                  <span class="overview-value">{{
                    listing?.details?.numOfCylinder
                  }}</span>
                </div>
                <div class="overview-row" v-if="listing?.details?.warranty">
                  <span class="overview-label">Warranty</span>
                  <span class="overview-value">{{
                    listing?.details?.warranty
                  }}</span>
                </div>

                <div class="overview-row" v-if="listing?.details?.makeModel">
                  <span class="overview-label">Make/Model</span>
                  <span class="overview-value">{{
                    listing?.details?.makeModel
                  }}</span>
                </div>
              </v-col>
              <!-- Vertical Divider -->
              <v-col cols="12" md="1" class="d-none d-md-flex justify-center">
                <div class="vertical-divider"></div>
              </v-col>
              <!-- Right Column -->
              <v-col cols="12" md="5">
                <div class="overview-row" v-if="listing.details.exterior_color">
                  <span class="overview-label">Exterior Color</span>
                  <span class="overview-value">{{
                    listing?.details?.exterior_color
                  }}</span>
                </div>
                <div
                  class="overview-row"
                  v-if="listing?.details?.interior_color"
                >
                  <span class="overview-label">Interior Color</span>
                  <span class="overview-value">{{
                    listing.details.interior_color
                  }}</span>
                </div>
                <div class="overview-row" v-if="listing?.details?.fuel_type">
                  <span class="overview-label">Fuel Type</span>
                  <span class="overview-value">{{
                    listing.details.fuel_type
                  }}</span>
                </div>
                <div class="overview-row" v-if="listing?.details?.horsepower">
                  <span class="overview-label">Horsepower</span>
                  <span class="overview-value"
                    >{{ listing.details.horsepower }} HP</span
                  >
                </div>
                <div
                  class="overview-row"
                  v-if="listing?.details?.transmission_type"
                >
                  <span class="overview-label">Transmission Type</span>
                  <span class="overview-value">{{
                    listing.details.transmission_type
                  }}</span>
                </div>

                <div class="overview-row" v-if="listing?.details?.trim">
                  <span class="overview-label">Trim</span>
                  <span class="overview-value">{{ listing.details.trim }}</span>
                </div>

                <div class="overview-row" v-if="listing?.details?.kilometers">
                  <span class="overview-label">Kilometers</span>
                  <span class="overview-value">{{
                    listing.details.kilometers
                  }}</span>
                </div>

                <div class="overview-row" v-if="listing?.details?.year">
                  <span class="overview-label">Year</span>
                  <span class="overview-value">{{ listing.details.year }}</span>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <!--End of Cars-->

        <!--Start of Motorcycle and others -->
        <v-row
          v-if="
            listingType === 'motorcycle' ||
            listingType === 'autoAccessory' ||
            listingType === 'heavyVehicle' ||
            listingType === 'boat' ||
            listingType === 'numberPlate' ||
            listingType === 'classified' ||
            listingType === 'community'
          "
        >
          <v-col cols="6" md="4">
            <div class="">
              <span class="currency-details">{{ currency }} </span> {{ " " }}
              <span class="price-details"> {{ formattedPrice }}</span>

              <span v-if="priceFrequency" class="body-2">
                {{ priceFrequency }}</span
              >
            </div>
            <div class="mt-2">
              <span v-if="city">
                <v-icon small class="mr-1">mdi-map-marker-outline</v-icon
                >{{ listing?.location.location_name }}, {{ "Somalia" }}</span
              >
            </div>
          </v-col>

          <v-col cols="6" md="4">
            <div class="mt-4 d-flex" style="margin-right: 80px">
              <v-btn
                dense
                small
                variant="outlined"
                class="mx-1 favorite-btn"
                @click="toggleFavorite"
              >
                <v-icon small left :color="isFavorited ? 'red' : ''"
                  >mdi-heart{{ isFavorited ? "" : "-outline" }}</v-icon
                >
                Favorite
              </v-btn>
              <v-btn
                dense
                small
                variant="outlined"
                class="mx-1 favorite-btn"
                @click="openShare(listing)"
              >
                <v-icon left>mdi-share-variant</v-icon>Share
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="4">
            <v-card class="agent-card-new pa-4" elevation="2">
              <v-row no-gutters align="center">
                <!-- Agent photo -->
                <v-col cols="3">
                  <v-avatar size="70" class="elevation-1" rounded="0">
                    <img
                      :src="agent?.agentPhoto || require('@/assets/avatar.png')"
                      alt="agent photo"
                      style="object-fit: cover; width: 100%; height: 70px"
                    />
                  </v-avatar>
                </v-col>
                <!-- Agent info -->
                <v-col cols="9" class="pl-2">
                  <div class="agent-name">{{ agent.agentName }}</div>
                  <!-- <router-link to="#_" class="agent-view-link">
                    {{
                      listingType === "motorcycle"
                        ? "View All Motorcycles"
                        : listingType === "autoAccessory"
                        ? "View All Auto Accessories"
                        : listingType === "heavyVehicle"
                        ? "View All Heavy Vehicles"
                        : listingType === "boat"
                        ? "View All Boats"
                        : listingType === "numberPlate"
                        ? "View All Number Plates"
                        : listingType === "classified"
                        ? "View All Classifieds"
                        : listingType === "community"
                        ? "View All Communities"
                        : ""
                    }}
                  </router-link> -->

                  <span class="agent-joined-date">
                    Joined on {{ agent.agentJoiningDate || "N/A" }}
                  </span>

                  <!-- <div class="agent-office">
            Urban Nest <br />
            Business Center <v-icon size="16" color="#8b8b8b">mdi-chevron-right</v-icon>
          </div> -->
                </v-col>
              </v-row>

              <v-row class="mt-4" no-gutters>
                <v-col>
                  <v-btn
                    class="contact-btn email"
                    :href="`mailto:?subject=${encodeURIComponent(
                      emailSubject
                    )}&body=${encodeURIComponent(currentShareUrl)}`"
                    variant="outlined"
                    block
                  >
                    <v-icon left color="#2260cf">mdi-email</v-icon>
                    Email
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    class="contact-btn call"
                    @click="callAgent"
                    variant="outlined"
                    block
                  >
                    <v-icon left color="#ef5959">mdi-phone</v-icon>
                    Call
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    class="contact-btn whatsapp"
                    :href="`https://wa.me/?text=${encodeURIComponent(
                      currentShareUrl
                    )}`"
                    target="_blank"
                    variant="outlined"
                    block
                  >
                    <v-icon color="#1bc557">mdi-whatsapp</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
            <div style="margin-top: 15px">
              <v-btn
                class="chat-seller-btn"
                :disabled="isSelf"
                @click="chatWithSeller"
                variant="flat"
              >
                <v-icon left>mdi-message-reply-text-outline</v-icon>
                Chat with Seller
              </v-btn>
            </div>
          </v-col>
          <v-divider class="my-4"></v-divider>

          <v-col
            cols="10"
            v-if="
              listingType === 'motorcycle' ||
              listingType === 'autoAccessory' ||
              listingType === 'heavyVehicle' ||
              listingType === 'boat' ||
              listingType === 'numberPlate' ||
              listingType === 'classified'
            "
          >
            <div>
              <div
                class="text-h6 font-weight-bold mb-4"
                v-if="
                  listingType === 'motorcycle' ||
                  listingType === 'autoAccessory' ||
                  listingType === 'heavyVehicle' ||
                  listingType === 'boat' ||
                  listingType === 'numberPlate' ||
                  listingType === 'classified'
                "
              >
                Item overview
              </div>
              <v-row class="overview-row" align="stretch" no-gutters>
                <!--MAKE-->

                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.make"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">MAKE</div>
                    <div class="overview-value mt-2 mr-4">
                      {{ listing?.details?.make }}
                    </div>
                  </v-card>
                </v-col>

                <!-- MODEL -->
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.model"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">MODEL</div>
                    <div class="overview-value mt-2 mr-4">
                      {{ listing?.details?.model }}
                    </div>
                  </v-card>
                </v-col>

                <!--Capacity/Weight-->
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.capacity_weight"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">CAPCITY/WEIGHT</div>
                    <div class="overview-value mt-2 mr-4">
                      {{ listing?.details?.capacity_weight }}
                    </div>
                  </v-card>
                </v-col>

                <!--Memory-->
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.memory"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">MEMORY</div>
                    <div class="overview-value mt-2 mr-4">
                      {{ listing?.details?.memory }}
                    </div>
                  </v-card>
                </v-col>

                <!-- AGE -->
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details.age"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">AGE</div>
                    <div class="overview-value mt-2 mr-4">
                      {{ listing?.details?.age }}
                    </div>
                  </v-card>
                </v-col>

                <!--Processor speed-->
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.processor"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">Processor Speed (Per Core)</div>
                    <div class="overview-value mt-2 mr-4">
                      {{ listing?.details?.processor }}
                    </div>
                  </v-card>
                </v-col>

                <!--USAGE-->

                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.usage"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">USAGE</div>
                    <div class="overview-value mt-2 mr-4">
                      {{ listing?.details?.usage }}
                    </div>
                  </v-card>
                </v-col>

                <!-- Condition-->
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.condition"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">CONDITION</div>
                    <div class="overview-value mt-2 mr-4">
                      {{ listing?.details?.condition }}
                    </div>
                  </v-card>
                </v-col>

                <!--Warranty-->

                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.warranty"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">WARRANTY</div>
                    <div class="overview-value mt-2 mr-4">
                      {{ listing?.details?.warranty }}
                    </div>
                  </v-card>
                </v-col>

                <!--Seller Type-->

                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.sellerType"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">SELLER TYPE</div>
                    <div class="overview-value mt-2 mr-4">
                      {{ listing?.details?.sellerType }}
                    </div>
                  </v-card>
                </v-col>
                <!-- KILOMETERS -->
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.kilometers"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">KILOMETERS</div>
                    <v-icon size="28" class="my-2" color="grey"
                      >mdi-speedometer</v-icon
                    >
                    <div class="overview-value mr-4">
                      {{ listing?.details?.kilometers }}
                    </div>
                  </v-card>
                </v-col>
                <!-- YEAR -->
                <v-col
                  cols="12"
                  sm="6"
                  md="2"
                  class="d-flex"
                  v-if="listing?.details?.year"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">YEAR</div>
                    <v-icon size="28" class="my-2" color="grey"
                      >mdi-calendar-outline</v-icon
                    >
                    <div class="overview-value mr-4">
                      {{ listing?.details?.year }}
                    </div>
                  </v-card>
                </v-col>
                <!-- FINAL DRIVE SYSTEM -->
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="d-flex"
                  v-if="listing?.details?.finalDriveSystem"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">FINAL DRIVE SYSTEM</div>
                    <div class="overview-value mt-2">
                      {{ listing?.details?.finalDriveSystem }}
                    </div>
                  </v-card>
                </v-col>
                <!-- WHEELS -->
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="d-flex"
                  v-if="listing?.details?.numOfWheels"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">WHEELS</div>
                    <div class="overview-value mt-2">
                      {{ listing?.details?.numOfWheels }}
                    </div>
                  </v-card>
                </v-col>

                <!--Number Plate -->

                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="d-flex"
                  v-if="listing?.details?.plate_number"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">PLATE NUMBER</div>
                    <div class="overview-value mt-2">
                      {{ listing?.details?.plate_number }}
                    </div>
                  </v-card>
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="d-flex"
                  v-if="listing?.details?.plate_code"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">PLATE CODE</div>
                    <div class="overview-value mt-2">
                      {{ listing?.details?.plate_code }}
                    </div>
                  </v-card>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="3"
                  class="d-flex"
                  v-if="listing?.details?.designType"
                >
                  <v-card class="overview-card flex-grow-1">
                    <div class="overview-title">PLATE STYLE</div>
                    <div class="overview-value mt-2">
                      {{
                        listing?.details?.designType === "classic"
                          ? "Classic Design"
                          : "Modern Design"
                      }}
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-divider class="mt-4"></v-divider>
        <v-row>
          <v-col cols="12" v-if="listingType === 'car'">
            <div
              class="text-h6 font-weight-bold mb-4"
              v-if="
                listingType === 'motorcycle' ||
                listingType === 'heavyVehicle' ||
                listingType === 'classified'
              "
            >
              Additional Details
            </div>
            <v-simple-table class="details-table" dense>
              <template #default>
                <tbody>
                  <tr v-if="listing?.details?.body_condition">
                    <td class="details-label">Body Condition</td>
                    <td class="details-value">
                      {{ listing?.details?.body_condition }}
                    </td>
                  </tr>
                  <tr v-if="listing?.details?.mechanical_condition">
                    <td class="details-label">Mechanical Condition</td>
                    <td class="details-value">
                      {{ listing?.details?.mechanical_condition }}
                    </td>
                  </tr>
                  <tr v-if="listing?.details?.engineSize">
                    <td class="details-label">Engine Size</td>
                    <td class="details-value">
                      {{ listing?.details?.engineSize }}
                    </td>
                  </tr>

                  <tr v-if="listing?.details?.sellerType">
                    <td class="details-label">Seller type</td>
                    <td class="details-value">
                      {{ listing?.details?.sellerType }}
                    </td>
                  </tr>

                  <tr v-if="listing?.details?.numOfCylinder">
                    <td class="details-label">No. of Cylinders</td>
                    <td class="details-value">
                      {{ listing?.details?.numOfCylinder }}
                    </td>
                  </tr>

                  <tr v-if="listing?.details?.horsepower">
                    <td class="details-label">Horsepower</td>
                    <td class="details-value">
                      {{ listing?.details?.horsepower }}
                    </td>
                  </tr>

                  <tr v-if="listing?.details?.model_name">
                    <td class="details-label">Model name</td>
                    <td class="details-value">
                      {{ listing?.details?.model_name }}
                    </td>
                  </tr>

                  <tr v-if="listing?.details?.warranty">
                    <td class="details-label">Warranty</td>
                    <td class="details-value">
                      {{ listing?.details?.warranty }}
                    </td>
                  </tr>

                  <tr v-if="listing?.details?.processor">
                    <td class="details-label">Processor Type</td>
                    <td class="details-value">
                      {{ listing?.details?.processor }}
                    </td>
                  </tr>

                  <tr v-if="listing?.details?.fuelType">
                    <td class="details-label">Fuel Type</td>
                    <td class="details-value">
                      {{ listing?.details?.fuelType }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-divider
          class="mt-4"
          v-if="listingType === 'motorcycle' || listingType === 'heavyVehicle'"
        ></v-divider>
        <!--End of Motorcycle-->

        <!-- TITLE & DESCRIPTION -->
        <v-row>
          <v-col col="8" md="8">
            <div class="text-h6 font-weight-bold mb-2">
              {{ listing.title }}
            </div>

            <!-- Reported by -->
            <v-alert
              v-if="hasReports"
              type="error"
              variant="outlined"
              density="compact"
              class="mb-4"
            >
              <div class="d-flex align-center flex-wrap">
                <strong class="mr-2">Reported by:</strong>
                <span class="mr-2">{{ reportedSummary }}</span>
                <v-chip
                  size="x-small"
                  class="ml-2"
                  color="error"
                  variant="flat"
                >
                  {{ reports.length }} report{{ reports.length > 1 ? "s" : "" }}
                </v-chip>

                <v-spacer />

                <v-btn
                  size="x-small"
                  variant="text"
                  @click="showReports = !showReports"
                >
                  {{ showReports ? "Hide details" : "View details" }}
                </v-btn>
              </div>

              <v-expand-transition>
                <div v-if="showReports" class="mt-3">
                  <v-list density="compact" lines="two">
                    <v-list-item
                      v-for="r in reports"
                      :key="r.id"
                      :title="r.reporter?.fullName || 'Unknown user'"
                      :subtitle="formatReportSubtitle(r)"
                    />
                  </v-list>
                </div>
              </v-expand-transition>
            </v-alert>

            <!-- PROPERTY DETAILS GRID, col-8, 2-column, full width, like second image -->
            <div
              class="property-details-grid mb-8"
              v-if="listingType === 'property'"
            >
              <div class="pdg-col">
                <div class="pdg-row">
                  <span class="pdg-label">Type</span>
                  <span class="pdg-value">{{ propertyType }}</span>
                </div>
                <div class="pdg-row">
                  <span class="pdg-label">Property Age</span>
                  <span class="pdg-value">{{ propertyAge }}</span>
                </div>
                <div class="pdg-row">
                  <span class="pdg-label">Bathrooms</span>
                  <span class="pdg-value">{{ bathrooms }}</span>
                </div>
                <div class="pdg-row">
                  <span class="pdg-label">Updated</span>
                  <span class="pdg-value pdg-bold">{{ postedOn }}</span>
                </div>
              </div>
              <div class="pdg-divider"></div>
              <div class="pdg-col">
                <div class="pdg-row">
                  <span class="pdg-label">Purpose</span>
                  <span class="pdg-value">{{
                    listing.category.name === "Property for Sale"
                      ? "Sale"
                      : "Rent"
                  }}</span>
                </div>
                <div class="pdg-row">
                  <span class="pdg-label">Furnishing</span>
                  <span class="pdg-value">{{ furnishing }}</span>
                </div>
                <div class="pdg-row">
                  <span class="pdg-label">Size</span>
                  <span class="pdg-value">{{ area }} Sqft</span>
                </div>
              </div>
            </div>

            <div class="body-1">
              {{ expanded ? listing.description : truncatedDescription }}
              <div>
                <a
                  href="#"
                  color="blue"
                  class="mt-2 mb-4 read-more-btn"
                  @click.prevent.stop="expanded = !expanded"
                >
                  {{ expanded ? "Show less" : "Read more" }}
                </a>
              </div>
              <!-- <div v-if="listingType === 'property'">
          <v-expand-transition>
            <div v-if="expanded" class="mb-6">
              <v-simple-table dense>
                <template #default>
                  <tbody>
                    <tr>
                      <td>Type</td>
                      <td></td>
                      <td>{{ listing.subcategory.name }}</td>
                    </tr>
                    <tr>
                      <td>Size</td>
                      <td></td>
                      <td>{{ area }} Sqft</td>
                    </tr>
                    <tr>
                      <td>Bathrooms</td>
                      <td></td>
                      <td></td>

                      <td>{{ bathrooms || "N/A" }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-expand-transition>
        </div> -->
            </div>

            <br />
            <div class="caption text--secondary mb-2">
              <span style="font-weight: bold">Posted on:</span> {{ postedOn }}
            </div>

            <v-divider></v-divider>
          </v-col>
        </v-row>

        <v-row
          v-if="
            (listing?.car || listing?.type === 'car') && featureColumns.length
          "
          class="moves-from-bottom"
        >
          <v-col cols="12">
            <h4 class="text-h6 mb-2">Features</h4>
          </v-col>

          <v-col cols="6">
            <div class="features-grid">
              <ul class="feature-list">
                <li v-for="name in featureColumns[0]" :key="`tf-1-${name}`">
                  <v-icon size="16" class="mr-2 text-success">mdi-check</v-icon>
                  <span>{{ name }}</span>
                </li>
              </ul>

              <ul class="feature-list">
                <li v-for="name in featureColumns[1]" :key="`tf-2-${name}`">
                  <v-icon size="16" class="mr-2 text-success">mdi-check</v-icon>
                  <span>{{ name }}</span>
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <!-- JOB APPLICATIONS -->
        <v-divider class="my-4" v-if="isJob && hasApplications"></v-divider>

        <v-row v-if="isJob && hasApplications">
          <v-col cols="12">
            <!-- Header / Controls -->
            <v-card class="pa-3 mb-3" variant="outlined">
              <div class="d-flex align-center flex-wrap">
                <div class="text-h6 font-weight-bold mr-2">Applications</div>
                <v-chip
                  class="mr-4"
                  size="small"
                  color="primary"
                  variant="flat"
                >
                  {{ applicationsCount }}
                  {{ applicationsCount === 1 ? "application" : "applications" }}
                </v-chip>

                <v-text-field
                  v-model="appsSearch"
                  prepend-inner-icon="mdi-magnify"
                  density="compact"
                  variant="outlined"
                  hide-details
                  placeholder="Search name, email, company..."
                  class="ml-auto"
                  style="max-width: 280px"
                />
              </div>
            </v-card>

            <!-- Compact list with sticky header -->
            <v-card variant="outlined">
              <div style="max-height: 420px; overflow: auto">
                <v-table density="compact" fixed-header>
                  <thead>
                    <tr>
                      <th style="width: 36px"></th>
                      <th>Name / Role</th>
                      <th class="text-no-wrap">Company</th>
                      <th class="text-no-wrap">Experience</th>
                      <th class="text-no-wrap">Location</th>
                      <th class="text-no-wrap">Education</th>
                      <th class="text-no-wrap">Applied</th>
                      <th class="text-right text-no-wrap">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="app in limitedApps" :key="app.id">
                      <!-- Avatar -->
                      <td>
                        <v-avatar size="28" color="grey-lighten-3">
                          <span class="text-caption">{{
                            initials(app.fullName)
                          }}</span>
                        </v-avatar>
                      </td>

                      <!-- Name / Role -->
                      <td>
                        <div class="font-weight-medium">{{ app.fullName }}</div>
                        <div class="text-caption grey--text">
                          {{ app.current_position || "—" }}
                        </div>
                      </td>

                      <!-- Company -->
                      <td class="text-caption">
                        {{ app.current_company || "—" }}
                      </td>

                      <!-- Experience -->
                      <td>
                        <v-chip size="x-small" variant="outlined">
                          {{ app.min_work_experience || "—" }}
                        </v-chip>
                      </td>

                      <!-- Location -->
                      <td class="text-caption">
                        {{ app.current_location || "—" }}
                      </td>

                      <!-- Education -->
                      <td class="text-caption">
                        {{ app.educationLevel || "—" }}
                      </td>

                      <!-- Applied date -->
                      <td class="text-caption">
                        {{ formatAppDate(app.created_at) }}
                      </td>

                      <!-- Actions -->
                      <td class="text-right">
                        <v-btn
                          v-if="app.cv_path"
                          size="x-small"
                          variant="text"
                          :href="cvUrl(app.cv_path)"
                          target="_blank"
                          :title="'Download CV'"
                          icon="mdi-file-download-outline"
                          class="mr-1"
                        />
                        <v-btn
                          v-if="app.email"
                          size="x-small"
                          variant="text"
                          :href="`mailto:${app.email}`"
                          :title="'Email'"
                          icon="mdi-email-outline"
                          class="mr-1"
                        />
                        <v-btn
                          v-if="app.phoneNumber"
                          size="x-small"
                          variant="text"
                          :href="`tel:${normalizePhone(app.phoneNumber)}`"
                          :title="'Call'"
                          icon="mdi-phone-outline"
                          class="mr-1"
                        />
                        <v-btn
                          size="x-small"
                          variant="text"
                          :title="'View details'"
                          icon="mdi-eye-outline"
                          @click="toggleDetails(app.id)"
                        />
                      </td>
                    </tr>

                    <!-- Inline details row -->
                    <tr v-for="app in detailsOpenApps" :key="`d-${app.id}`">
                      <td></td>
                      <td colspan="7" class="py-2">
                        <v-expand-transition>
                          <v-card class="pa-3" variant="tonal">
                            <v-row dense>
                              <v-col cols="12" md="6">
                                <v-list density="compact">
                                  <v-list-item
                                    title="Email"
                                    :subtitle="app.email || '—'"
                                  />
                                  <v-list-item
                                    title="Phone"
                                    :subtitle="app.phoneNumber || '—'"
                                  />
                                  <v-list-item
                                    title="Nationality"
                                    :subtitle="app.nationality || '—'"
                                  />
                                  <v-list-item
                                    title="Gender"
                                    :subtitle="app.gender || '—'"
                                  />
                                </v-list>
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-list density="compact">
                                  <v-list-item
                                    title="Notice Period"
                                    :subtitle="app.notice_period || '—'"
                                  />
                                  <v-list-item
                                    title="Visa Status"
                                    :subtitle="app.visaStatus || '—'"
                                  />
                                  <v-list-item
                                    title="Job Status"
                                    :subtitle="app.jobStatus || '—'"
                                  />
                                </v-list>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-expand-transition>
                      </td>
                    </tr>

                    <tr v-if="!limitedApps.length">
                      <td
                        colspan="8"
                        class="text-center py-6 grey--text text-caption"
                      >
                        No applications match your search.
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </div>

              <!-- Show more / less -->
              <v-divider />
              <div
                class="d-flex justify-center py-2"
                v-if="filteredApps.length > limit"
              >
                <v-btn
                  size="small"
                  variant="text"
                  @click="showAllApps = !showAllApps"
                >
                  {{
                    showAllApps
                      ? "Show less"
                      : `Show all ${filteredApps.length}`
                  }}
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <!-- /JOB APPLICATIONS -->

        <!-- AMENITIES GRID -->

        <v-col cols="12" md="6" v-if="listingType === 'property'">
          <div class="text-h6 font-weight-medium mb-4">Amenities</div>

          <v-row>
            <v-col cols="3" v-for="(a, i) in amenities" :key="i">
              <div class="amenity-card d-flex flex-column align-center">
                <v-img
                  :src="imgUrl(a.icon)"
                  alt=""
                  width="40"
                  height="40"
                  class="mb-2"
                  contain
                />
                <span class="body-2 text-center">{{ a.name }}</span>
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-divider class="my-4"></v-divider>

        <!-- MAP VIEW -->
        <v-row dense v-if="location">
          <v-col cols="12">
            <div class="text-h6 font-weight-medium mb-2">Map View</div>
            <v-responsive class="mb-6" aspect-ratio="16/9">
              <iframe
                :src="`https://www.google.com/maps?q=${location.lat},${location.lng}&z=15&output=embed`"
                width="600px"
                height="300px"
                style="border: 0"
                allowfullscreen
                loading="lazy"
              ></iframe>
            </v-responsive>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <!-- CONTACT INFO  -->
        <v-row dense class="mb-6" v-if="phone">
          <v-col cols="12" md="6">
            <div class="d-flex align-center mb-2">
              <div class="text-h6 font-weight-medium">Contact Information</div>
              <v-icon small color="success" class="ml-2"
                >mdi-check-circle</v-icon
              >
            </div>
            <v-simple-table dense>
              <template #default>
                <tbody>
                  <tr>
                    <td>Phone:</td>
                    <td>{{ phone }}</td>
                  </tr>
                  <tr>
                    <td>Email:</td>
                    <td>{{ email }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row v-if="transaction">
          <v-col cols="12" md="6">
            <div class="d-flex align-center mb-2">
              <div class="text-h6 font-weight-medium">Transaction</div>
              <v-icon small color="success" class="ml-2"
                >mdi-check-circle</v-icon
              >
            </div>
            <v-simple-table dense>
              <template #default>
                <tbody>
                  <tr>
                    <td>Amount</td>
                    <td></td>
                    <td></td>
                    <td>
                      {{ transaction.currency }} {{ " "
                      }}{{ formattedTransactionAmount }}
                    </td>
                  </tr>
                  <tr>
                    <td>Phone</td>
                    <td></td>
                    <td></td>
                    <td>{{ transaction.phoneNumber }}</td>
                  </tr>
                  <tr>
                    <td>Payment Method</td>
                    <td></td>
                    <td></td>
                    <td>{{ transaction.paymentMethod }}</td>
                  </tr>
                  <tr>
                    <td>Status</td>
                    <td></td>
                    <td>
                      <v-chip :color="statusColor" dark small>
                        {{ transaction.status }}
                      </v-chip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <!-- <div
        v-if="listing.status !== 2"
        :class="['stamp', listing.status === 1 ? 'approved' : 'rejected']"
      >
        {{ listing.status === 1 ? "APPROVED" : "REJECTED" }}
      </div> -->

        <!-- APPROVE / REJECT BUTTONS -->
        <!-- <v-card-actions class="justify-end" v-if="listing.status === 2"> -->
        <v-card-actions class="justify-end" v-if="listing.status !== 0">
          <!-- Reject as a red outline pill -->
          <v-btn
            style="text-transform: none"
            v-if="listing.status !== 3"
            color="error"
            variant="outlined"
            rounded="pill"
            class="mx-2"
            :loading="props.loadingReject"
            :disabled="props.loadingReject"
            @click="$emit('reject')"
          >
            <v-icon left class="mr-1">mdi-close-circle-outline</v-icon>
            Reject
          </v-btn>

          <v-btn
            style="text-transform: none"
            v-if="props.listing.verified !== 1"
            color="info"
            variant="contained"
            rounded="pill"
            class="mx-2"
            :loading="props.loadingVerify"
            :disabled="props.loadingVerify"
            @click="() => emit('verify', props.listing)"
          >
            <v-icon left class="mr-1">mdi-check-decagram-outline</v-icon>
            Verify
          </v-btn>

          <!-- Approve as a solid green pill -->
          <v-btn
            style="text-transform: none"
            v-if="listing.status !== 1"
            color="success"
            variant="contained"
            rounded="pill"
            elevation="2"
            class="mx-2"
            :loading="props.loadingApprove"
            :disabled="props.loadingApprove"
            @click="() => emit('approve', props.listing)"
          >
            <v-icon left class="mr-1">mdi-check-circle-outline</v-icon>
            Approve
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- share dialog -->
    <v-dialog v-model="shareDialog" max-width="800px">
      <v-card>
        <v-card-title class="d-flex align-center">
          Share this listing
          <v-spacer />
          <v-btn icon @click="shareDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <!-- social buttons row -->
          <v-row justify="space-around" class="mb-4">
            <!-- WhatsApp -->
            <v-btn
              icon
              :href="`https://wa.me/?text=${encodeURIComponent(
                currentShareUrl
              )}`"
              target="_blank"
            >
              <v-icon color="#25D366">mdi-whatsapp</v-icon>
            </v-btn>

            <!-- Facebook -->
            <v-btn
              icon
              :href="`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                currentShareUrl
              )}`"
              target="_blank"
            >
              <v-icon color="#3b5998">mdi-facebook</v-icon>
            </v-btn>

            <!-- X (Twitter) -->
            <v-btn
              icon
              :href="`https://twitter.com/intent/tweet?url=${encodeURIComponent(
                currentShareUrl
              )}`"
              target="_blank"
            >
              <v-icon color="#1DA1F2">mdi-twitter</v-icon>
            </v-btn>

            <!-- LinkedIn -->
            <v-btn
              icon
              :href="`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                currentShareUrl
              )}`"
              target="_blank"
            >
              <v-icon color="#0077B5">mdi-linkedin</v-icon>
            </v-btn>

            <!-- Email -->
            <v-btn
              icon
              :href="`mailto:?subject=${encodeURIComponent(
                emailSubject
              )}&body=${encodeURIComponent(currentShareUrl)}`"
            >
              <v-icon color="#9c27b0">mdi-email</v-icon>
            </v-btn>
          </v-row>

          <!-- copy field -->
          <v-text-field
            v-model="currentShareUrl"
            readonly
            hide-details
            append-inner-icon="mdi-content-copy"
            @click:append-inner="copyLink"
            label="Link"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="copyLink">Copy</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import moment from "moment";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { API_URL } from "@/helpers/api.js";
import { doc, setDoc, writeBatch, serverTimestamp } from "firebase/firestore";
import { db } from "@/db";
//import { ref as dbRef, set, get, serverTimestamp } from "firebase/database";

const store = useStore();
const router = useRouter();
const user = computed(() => store.state.auth.user);

console.log("user now ", user.value);

const shareDialog = ref(false);
const currentShareUrl = ref("");

const props = defineProps({
  modelValue: Boolean,
  listing: {
    type: Object,
    required: true,
  },
  loadingApprove: { type: Boolean, default: false },
  loadingReject: { type: Boolean, default: false },
  loadingVerify: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue", "approve", "reject", "verify"]);
const show = computed({
  get: () => props.modelValue,
  set: (v) => emit("update:modelValue", v),
});

const expanded = ref(false);

const emailSubject = ref(typeof document !== "undefined" ? document.title : "");

const truncatedDescription = computed(() => {
  const d = props.listing.description || "";
  return d.length > 50 ? d.slice(0, 50).trim() + "…" : d;
});

// Sync v-model
watch(
  () => props.modelValue,
  (val) => (show.value = val)
);
watch(show, (val) => {
  if (!val) emit("update:modelValue", false);
});

function close() {
  show.value = false;
}

// Hero images
const mainImage = computed(() => {
  const url = props.listing?.files?.[0]?.url || "";
  return url.startsWith("http") ? url : `${API_URL}${url}`;
});

//console.log("This image", mainImage.value);

const otherImages = computed(() =>
  (props.listing?.files || []).slice(1, 3).map((f) => {
    const url = f.url || "";
    return url.startsWith("http") ? url : `${API_URL}${url}`;
  })
);

watch(
  () => props.listing,
  (l) => {
    console.log("listing prop:", l);
    console.log("mainImage:", mainImage.value);
    console.log("otherImages:", otherImages.value);
  },
  { immediate: true }
);

// Price
const formattedPrice = computed(() => {
  const p = props.listing.price;
  return p != null ? Number(p).toLocaleString("en-US") : 0;
});
const priceFrequency = computed(() =>
  props.listing?.property?.pricePerYear ? "Yearly" : ""
);

const currency = computed(
  () => props.listing?.city?.country?.currency ?? "USD"
);

const listingType = computed(() => props.listing?.type ?? "");

// Verification & basic stats
const isVerified = computed(() => props.listing.verified === 1);
const bedrooms = computed(() => props.listing.property?.bedrooms);
const bathrooms = computed(() => props.listing.property?.bathrooms);
const area = computed(() => props.listing.details?.size);
const city = computed(() => props.listing.city?.title);
const country = computed(() => props.listing.city?.country?.name);

// Dates & timestamps
const postedOn = computed(() =>
  moment(props.listing.created_at).format("D MMMM YYYY")
);
const propertyAge = computed(() => {
  const d = props.listing.created_at;
  if (!d) return "N/A";
  const yrs = moment().diff(moment(d), "years");
  return yrs > 0 ? `${yrs} year${yrs > 1 ? "s" : ""}` : "Less than 1 year";
});

// Other fields
const propertyType = computed(
  () =>
    props.listing.subCategory?.title || props.listing.category?.title || "N/A"
);
const region = computed(() => props.listing.city?.name || "N/A");
const furnishing = computed(() =>
  props.listing.property?.isFurnished ? "Furnished" : "Unfurnished"
);
const availability = computed(() =>
  props.listing.status === 1 ? "Available" : "Not Available"
);

const location = computed(() => props.listing.location || null);

const phone = computed(() => props.listing.contactInformation ?? null);

const email = computed(() => props.listing.user.email ?? null);

// Amenities (from either property or details)
const amenities = computed(() => {
  const source = props.listing.details?.amenities || [];
  return source.map((a) => ({
    name: a.name,
    icon: a.icon_svg || "mdi-check",
  }));
});

// Building info (fill in with whatever your backend provides)
const building = computed(() => ({
  parking: props.listing.building?.parking ?? "N/A",
  floorCount: props.listing.building?.floorCount ?? "N/A",
  elevators: props.listing.building?.elevators ?? "N/A",
  name: props.listing.building?.name ?? "N/A",
  area: props.listing.building?.area ?? "N/A",
  completionYear: props.listing.building?.completionYear ?? "N/A",
}));

const transaction = computed(() => ({
  amount: props.listing.transaction?.amount ?? 0,
  paymentMethod: props.listing.transaction?.paymentMethod ?? "N/A",
  phoneNumber: props.listing.transaction?.phoneNumber ?? "N/A",
  status: props.listing.transaction?.status ?? "N/A",
  currency: props.listing.transaction?.currency ?? "USD",
}));

const statusColor = computed(() => {
  const status = props.listing?.transaction?.status?.toLowerCase();
  switch (status) {
    case "pending":
      return "orange";
    case "completed":
      return "green";
    default:
      return "grey";
  }
});

const formattedTransactionAmount = computed(() => {
  const p = props.listing.transaction?.amount;
  return p != null ? Number(p).toLocaleString("en-US") : 0;
});

// Agent info
const agent = computed(() => ({
  agentName: props.listing?.user?.fullName,
  agentPhoto: props.listing?.user?.photo,
  agentJoiningDate: props.listing?.user?.created_at
    ? moment(props.listing.user.created_at).format("MMMM YYYY")
    : "N/A",
}));
function approveListing() {
  emit("approve", props.listing);
  close();
}

function verifyListing() {
  emit("verify", props.listing);
  close();
}

function rejectListing() {
  emit("reject", props.listing);
  close();
}

function imgUrl(path) {
  if (!path) return "";
  return path.startsWith("http") ? path : `${API_URL}/storage/${path}`;
}

const isSelf = computed(() => {
  return user.value?.id === props.listing.user?.id;
});

const chatWithSeller = async () => {
  const buyerId = user.value.id.toString();
  const sellerId = props.listing.user.id.toString();
  const listingId = props.listing.id.toString();

  if (buyerId === sellerId) return;

  const buyerListingDoc = doc(db, buyerId, "chats", "listing", listingId);
  const sellerListingDoc = doc(db, sellerId, "chats", "listing", listingId);

  const batch = writeBatch(db);
  batch.set(buyerListingDoc, { withUserId: sellerId }, { merge: true });
  batch.set(sellerListingDoc, { withUserId: buyerId }, { merge: true });

  await batch.commit();

  router.push({
    name: "ChatWindow",
    params: {
      listingId: listingId,
      sellerId: sellerId,
    },
  });
};

// async function chatWithSeller() {
//   const buyerId = user.value.id.toString();
//   const sellerId = props.listing.user.id.toString();
//   const listingId = props.listing.id.toString();

//   // no self-chat
//   if (buyerId === sellerId) return;

//   // prepare the two listing-docs (they’ll be empty but let Firestore show them)
//   const buyerListingDoc = doc(db, buyerId, "chats", "listing", listingId);
//   const sellerListingDoc = doc(db, sellerId, "chats", "listing", listingId);

//   // one batch to create both
//   const batch = writeBatch(db);
//   batch.set(buyerListingDoc, {}, { merge: true });
//   batch.set(sellerListingDoc, {}, { merge: true });
//   await batch.commit();

//   // now route into your chat window
//   router.push({
//     name: "ChatWindow",
//     params: { listingId, sellerId },
//   });
// }

const isFavorited = computed(() =>
  store.getters["favorite/isFavorited"](props.listing.id)
);

// const toggleFavorite = async () => {
//   const listId = store.getters["favoriteList/activeId"];

//   if (!isFavorited.value) {
//     await store.dispatch("favorite/addFavorite", {
//       listing_id: props.listing.id,
//       favorite_list_id: listId,
//     });
//   } else {
//     const favRecordId = store.getters["favorite/getFavoriteRecordId"](props.listing.id);
//     await store.dispatch("favorite/removeFavorite", favRecordId);
//   }
//   // re-fetch so the list thumbnail updates
//   await store.dispatch("favorite/fetchFavorites", listId);
// };

const toggleFavorite = async () => {
  const listId = store.getters["favoriteList/activeId"];

  if (!isFavorited.value) {
    await store.dispatch("favorite/addFavorite", {
      listing_id: props.listing.id,
      favorite_list_id: listId,
    });
    await store.dispatch("alert/success", "Added to favorites");
  } else {
    await store.dispatch("favorite/removeFavorite", props.listing.id);
    await store.dispatch("alert/success", "Removed from favorites");
  }

  await store.dispatch("favorite/fetchFavorites", listId);
};

function openShare(listing) {
  const slug = slugify(listing.title);

  console.log("Listing object", listing);
  // build whatever URL your site uses; here I’m assuming slug or fallback to ID
  currentShareUrl.value = `${window.location.origin}/listing/${listing.id}/${slug}`;
  shareDialog.value = true;
}

// copy to clipboard, with a tiny confirmation (you can swap in a snackbar)
async function copyLink() {
  try {
    await navigator.clipboard.writeText(currentShareUrl.value);
    // e.g. console.log('Copied!', currentShareUrl.value)
    store.dispatch("alert/success", "Copied!");
  } catch (e) {
    console.error("Copy failed", e);
  }
}

const reports = computed(() => props.listing?.reports ?? []);
const hasReports = computed(() => reports.value.length > 0);
const showReports = ref(false);

// const reportedNames = computed(() => {
//   // unique reporter names, show up to 3
//   const names = Array.from(
//     new Set(reports.value.map((r) => r.reporter?.fullName || "Unknown"))
//   );
//   const preview = names.slice(0, 3).join(", ");
//   return names.length > 3 ? `${preview} +${names.length - 3} more` : preview;
// });

const reportedSummary = computed(() => {
  // unique combos of name+phone, up to 3 in the summary
  const seen = new Set();
  const parts = [];
  for (const r of reports.value) {
    const name = r.reporter?.fullName || "Unknown";
    const phone = r.reporter?.phoneNumber || "N/A";
    const key = `${name}|${phone}`;
    if (!seen.has(key)) {
      seen.add(key);
      parts.push(`${name} (${phone})`);
    }
  }
  const preview = parts.slice(0, 3).join(", ");
  return parts.length > 3 ? `${preview} +${parts.length - 3} more` : preview;
});

function phoneLabel(phone) {
  return phone ? ` (${phone})` : "";
}

function formatReportSubtitle(r) {
  const when = r.created_at
    ? moment(r.created_at).format("D MMM YYYY, HH:mm")
    : "";
  const why = r.description || "No reason provided";
  return when ? `${why} — ${when}` : why;
}

// Job Section

const appsSearch = ref("");
const showAllApps = ref(false);
const rowDetailsOpen = ref(new Set()); // track open detail rows
const isJob = computed(() =>
  props.listing?.type || props.listing?.job
    ? props.listing.type === "job"
    : false
);
const applications = computed(
  () =>
    props.listing?.job?.applications ??
    props.listing?.details?.applications ??
    []
);
const applicationsCount = computed(() => applications.value.length);
const hasApplications = computed(() => applicationsCount.value > 0);

// Search / limit
const filteredApps = computed(() => {
  const q = appsSearch.value.trim().toLowerCase();
  if (!q) return applications.value;
  return applications.value.filter((a) => {
    return [
      a.fullName,
      a.email,
      a.current_company,
      a.current_position,
      a.current_location,
    ]
      .filter(Boolean)
      .some((v) => String(v).toLowerCase().includes(q));
  });
});

const limit = 10;
const limitedApps = computed(() =>
  showAllApps.value ? filteredApps.value : filteredApps.value.slice(0, limit)
);

// Inline details
function toggleDetails(id) {
  if (rowDetailsOpen.value.has(id)) {
    rowDetailsOpen.value.delete(id);
  } else {
    rowDetailsOpen.value.add(id);
  }
  // force reactivity by replacing the Set
  rowDetailsOpen.value = new Set(rowDetailsOpen.value);
}
const detailsOpenApps = computed(() =>
  limitedApps.value.filter((a) => rowDetailsOpen.value.has(a.id))
);

// Small helpers
function initials(name) {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() || "").join("");
}
function normalizePhone(p) {
  return String(p || "").replace(/[^\d+]/g, "");
}
function formatAppDate(dt) {
  return dt ? moment(dt).format("D MMM YYYY, HH:mm") : "—";
}
function cvUrl(path) {
  if (!path) return "";
  return path.startsWith("http") ? path : `${API_URL}/storage/${path}`;
}

const carFeatures = ref([
  { id: 1, name: "Front Wheel Drive" },
  { id: 2, name: "Rear Wheel Drive" },
  { id: 3, name: "All Wheel Drive" },
  { id: 4, name: "TipTronic Gears" },
  { id: 5, name: "Anti-Lock Brakes/ABS" },
  { id: 6, name: "Cruise Control" },
  { id: 7, name: "DSG Gearbox" },
  { id: 8, name: "Parking Sensors" },
  { id: 9, name: "Rear Camera" },
  { id: 10, name: "Bluetooth" },
  { id: 11, name: "Navigation System" },
  { id: 12, name: "Sunroof" },
  { id: 13, name: "Leather Seats" },
  { id: 14, name: "Climate Control" },
  { id: 15, name: "Keyless Entry" },
  { id: 16, name: "Turbo Charged" },
]);

// Parse selected feature IDs from listing (handles string like "[3,4,...]" or array)
const selectedFeatureIds = computed(() => {
  let raw = props.listing?.features ?? [];
  if (typeof raw === "string") {
    try {
      raw = JSON.parse(raw);
    } catch {
      // fallback: "3,4,6" → [3,4,6]
      raw = raw
        .replace(/\[|\]/g, "")
        .split(",")
        .map((n) => parseInt(n.trim(), 10))
        .filter((n) => Number.isFinite(n));
    }
  }
  return Array.isArray(raw)
    ? raw.map((n) => Number(n)).filter((n) => Number.isFinite(n))
    : [];
});

// Map IDs → names using carFeatures
const selectedFeatureNames = computed(() => {
  const map = new Map(carFeatures.value.map((f) => [f.id, f.name]));
  return selectedFeatureIds.value.map((id) => map.get(id)).filter(Boolean);
});

// Split into 2 columns (balanced)
const featureColumns = computed(() => {
  const names = selectedFeatureNames.value;
  if (!names.length) return [];
  const perCol = Math.ceil(names.length / 2);
  return [names.slice(0, perCol), names.slice(perCol)];
});
</script>

<style scoped>
.hero-wrapper {
  position: relative;
}
.verified-badge {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 10;
}

.agent-card-new {
  border-radius: 16px !important;
  box-shadow: 0 2px 12px rgba(56, 77, 97, 0.08);
}

.agent-name {
  font-size: 1.12rem;
  font-weight: 600;
  color: #212121;
  margin-bottom: 2px;
}

.agent-view-link {
  font-family: proxima-nova, ProximaNova, noto, GESS, GE-SS, "Helvetica Neue",
    Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  color: rgb(58, 136, 239);
  text-decoration: none;
}

.agent-office {
  color: #7c7c7c;
  font-size: 0.96rem;
  margin-top: 2px;
}

.contact-btn {
  border-radius: 10px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  min-width: 0;
  padding: 0 10px !important;
  background: #f7fafd !important; /* fallback */
  box-shadow: none !important;
  height: 38px !important;
  font-size: 1rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none !important;
  margin-right: 8px;
  color: #222 !important; /* Makes the button text black */
}

.contact-btn.email {
  background: #eaf3fc !important;
}

.contact-btn.call {
  background: #ffeaea !important;
}

.contact-btn.whatsapp {
  background: #e7f9ef !important;
}

.contact-btn .v-icon {
  margin-right: 6px;
  font-size: 20px !important;
}

/* Icon colors (override inherited color) */
.contact-btn.email .v-icon {
  color: #2260cf !important;
}
.contact-btn.call .v-icon {
  color: #ef5959 !important;
}
.contact-btn.whatsapp .v-icon {
  color: #1bc557 !important;
  margin-right: 0;
}

.agent-btn.whatsapp {
  background-color: #25d366; /* WhatsApp green */
  border-radius: 10px;
  opacity: 0.5;
}

.listing-info-table td {
  padding: 12px 16px;
  vertical-align: top;
}

/* Light border under each row */
.listing-info-table tr + tr td {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.amenity-img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.amenity-card {
  background-color: #f5f5f5; /* light gray background */
  border-radius: 8px; /* rounded corners */
  padding: 2px; /* space around icon & text */
  height: 100%; /* make cards same height */
  justify-content: center; /* vertically center content */
}

.v-card-actions .v-btn {
  min-width: 120px;
}

.stamp {
  position: relative;
  top: 1rem; /* tweak to your taste */
  right: 1rem; /* push it in from the right edge */
  transform: rotate(-15deg);
  font-size: 2rem;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.1);
  /* lighten or darken for better contrast */
  pointer-events: none;
  white-space: nowrap;
}

.stamp.approved {
  color: rgba(76, 175, 80, 0.3); /* greenish */
}

.stamp.rejected {
  color: rgba(244, 67, 54, 0.3); /* reddish */
}
.price-details {
  font-family: proxima-nova, ProximaNova, noto, GESS, GE-SS, "Helvetica Neue",
    Helvetica, Arial, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.87);
}

.currency-details {
  font-family: proxima-nova, ProximaNova, noto, GESS, GE-SS, "Helvetica Neue",
    Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.87);
}

.view-all-properties-link {
  font-family: proxima-nova, ProximaNova, noto, GESS, GE-SS, "Helvetica Neue",
    Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  color: rgb(58, 136, 239);
}
.read-more-btn {
  font-family: proxima-nova, ProximaNova, noto, GESS, GE-SS, "Helvetica Neue",
    Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  color: rgb(58, 136, 239);
  text-decoration: none;
}

.favorite-btn {
  border-radius: 8px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 3;
  font-size: 14px;
}

.overview-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  font-size: 1rem;
}

.overview-label {
  color: #222;
}

.overview-value {
  font-weight: 600;
  color: #1a1a1a;
  margin-left: 12px;
  /* For labels like "Red" you can add inline style if you want them colored */
}

.vertical-divider {
  width: 1px;
  background-color: #e0e0e0;
  height: 100%;
  min-height: 260px;
  margin: 0 auto;
}

.overview-row {
  gap: 35px;
}

.overview-card {
  min-width: 160px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 14px rgba(30, 32, 37, 0.08);
  padding: 20px 0 16px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: box-shadow 0.2s;
}

.overview-title {
  font-weight: bold;
  color: #222;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  margin-bottom: 2px;
  font-family: proxima-nova, ProximaNova, noto, GESS, GE-SS, "Helvetica Neue",
    Helvetica, Arial, sans-serif;
  font-size: 12px;
  line-height: 20px;
  color: rgb(43, 45, 46);
}

.overview-value {
  color: #181818;
  font-weight: 400;
  text-align: center !important;
  font-family: proxima-nova, ProximaNova, noto, GESS, GE-SS, "Helvetica Neue",
    Helvetica, Arial, sans-serif;
  font-size: 13px;
  line-height: 20px;
  color: rgb(43, 45, 46);
}

.details-table {
  width: 100%;
  background: transparent;
  font-size: 1rem;
}

.details-label {
  font-weight: 600;
  color: #181818;
  padding: 16px 0 16px 0;
  min-width: 180px;
}
.details-value {
  text-align: left;
  color: #181818;
  font-weight: 400;
  padding: 16px 0 16px 0;
}
.details-table tr:not(:last-child) td {
  border-bottom: 1px solid #ededed !important;
}

.chat-seller-btn {
  background: #e60000 !important; /* Bright red */
  color: #fff !important; /* White text/icon */
  font-family: "Proxima Nova", "proxima-nova", "ProximaNova", "Helvetica Neue",
    Helvetica, Arial, sans-serif !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  border-radius: 5px !important; /* Rectangle with slightly rounded corners */
  padding: 14px 28px !important;
  min-width: 400px; /* Wide like the screenshot */
  box-shadow: none !important;
  letter-spacing: 0.1px;
  text-transform: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  height: auto;
}

.chat-seller-btn .v-icon {
  margin-right: 10px;
  color: #fff !important; /* Ensure icon is white */
  font-size: 22px !important;
}

.chat-seller-btn:hover,
.chat-seller-btn:focus-visible {
  background: #b80000 !important; /* Slightly darker red on hover */
}

.chat-seller-btn:disabled {
  opacity: 0.65 !important;
  background: #e60000 !important;
  color: #fff !important;
  cursor: not-allowed;
}

.property-details-grid {
  display: flex;
  background: transparent;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 32px;
}

.pdg-col {
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pdg-row {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  gap: 28px;
  min-height: 36px;
  font-size: 18px;
}

.pdg-label {
  font-weight: 500;
  color: #222;
  min-width: 120px;
  font-size: 17px;
}

.pdg-value {
  font-weight: 400;
  color: #181818;
  font-size: 17px;
}

.pdg-bold {
  font-weight: 700;
  color: #181818;
}

.pdg-divider {
  width: 1px;
  background: #e0e0e0;
  margin: 0 38px;
  min-height: 124px;
}

.features-grid {
  display: grid;
  grid-template-columns: 1fr 1fr ;
  gap: 0.1rem !important; /* adjust this value to control spacing */
}

@media (max-width: 960px) {
  .features-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0;
}


</style>
